export class NavigationItem {
  constructor(
    public id: string,
    public label: string,
    public icon: string = '',
    public color: string = ''
  ) {}
}
